import { useCallback, useState } from 'react';
import { type StreamForStreamDashboard } from 'Lessons';
import { isChapterComplete } from '../selectors';

/*
    Which chapters are open. All incomplete chapters start open. Seed in useState so the first paint is
    correct.
*/
export function useChapterExpansion(stream: StreamForStreamDashboard) {
    const [expandedChapterIndexes, setExpandedChapterIndexes] = useState(
        () =>
            new Set(
                stream.chapters
                    .map((chapter, index) => ({ chapter, index }))
                    .filter(({ chapter }) => !isChapterComplete(stream, chapter))
                    .map(({ index }) => index),
            ),
    );

    const toggleChapter = useCallback((index: number) => {
        setExpandedChapterIndexes(previous => {
            const next = new Set(previous);
            if (next.has(index)) next.delete(index);
            else next.add(index);
            return next;
        });
    }, []);

    const isChapterExpanded = useCallback(
        (index: number) => expandedChapterIndexes.has(index),
        [expandedChapterIndexes],
    );

    return { isChapterExpanded, toggleChapter };
}
